import { Component, OnInit, Input } from '@angular/core';
import * as Chart from 'chart.js'

@Component({
  selector: 'app-items-prices-uyu',
  templateUrl: './items-prices-uyu.component.html',
  styleUrls: ['./items-prices-uyu.component.css']
})
export class ItemsPricesUyuComponent implements OnInit {

  constructor() { }

  @Input() graphData;

  ngOnInit(){
  }

  title = 'angular8chartjs';
  canvas: any;
  ctx: any;

  ngAfterViewInit() {
    this.canvas = document.getElementById("items-prices-uyu-chart");
    this.ctx = this.canvas.getContext("2d");
    var myLineChart = new Chart(this.ctx, {
      type: 'line',
      data: {
				labels: this.graphData.labels,
				datasets: this.graphData.price_uyu_graph
      },
      options: {
        xAxes: [{
          type: 'time',
          time: {
            unit: 'day'
          }
        }],
        responsive: false,
        display : true,
        maintainAspectRatio: true,
        legend: {
          display: false
        }
      }
  });
  }
}
